module.exports = "##### Information\n\nWe use this color for content that generally don't require an action, but that might be of interest to the user.\n"